export enum ChartItemColor {
  gray,
  lightGray,
  darkGray,
  blue,
  red,
  green,
  teal,
  purple,
  violet,
  emerald,
  orange,
  pink,
  lime,
  yellow,
}

export type ChartItemColorType = keyof typeof ChartItemColor

export const CHART_ITEM_COLORS: Record<ChartItemColorType, string> = {
  gray: 'text-gray-200 dark:text-gray-700',
  lightGray: 'text-gray-400',
  darkGray: 'text-gray-700 dark:text-gray-300',
  blue: 'text-blue-400',
  red: 'text-red-400',
  green: 'text-green-400',
  teal: 'text-teal-400 dark:text-teal-300',
  purple: 'text-purple-400',
  violet: 'text-violet-400',
  emerald: 'text-emerald-400 dark:text-emerald-300',
  orange: 'text-orange-300',
  pink: 'text-pink-400',
  lime: 'text-lime-400 dark:text-lime-300',
  yellow: 'text-yellow-300 dark:text-yellow-200',
}
